
import React from 'react';
import BannerMenu from "../BannerMenu";
import { sprintf } from "sprintf-js";
import { dollarToString } from "../../../lib/currency-utils";
import { getRGB } from "../../../lib/color";
import {DEVICE_WIDTH, AccountTypeLabel} from "../../../lib/constants";
import PortfolioDashboard from "../PortfolioDashboard";
import PersonalDashboard from "../PersonalInfoDashboard";
import { addAccount } from "../../onboarding/actions";
import {Spinner, TextLoading, DashboardContainer, Action} from "../../funcs/utils";
import AccountPopupMenu from "../AccountPopupMenu";
import PaymentsDashboard from "../PaymentsDashboard";
import EmailDashboard from "../../inbox/InboxDashboard";
import {deep_copy} from "../../../lib/js-utils";
import Chat from "../../chat/Chat/chat"
import "./styles.scss";
import {objToUrlParam} from "../../../lib/url-util";
import {Balances} from "./balances_card";
// import { Performance } from "./performance_card";
import {Greeting} from "./greeting";
import {maybe_load_invites, UGMAInvite} from "./ugma-invite";
import {IRAMinimumDistribution} from "./minDistributionCalc/ira-minimum-distribution";
import {RetirementCalculator} from "./retirement-calculator";
import Statements from "../Statements";
import {SecurityPurchasesCard} from "./security-purchases-card";
import {onboarding_start_segment} from "../../../lib/onboarding-utils";
import CurrentOfferings from "../../cd/CurrentOfferings";
import {USTCard} from "./UST_card";
import {CouponStats} from "./coupon_stats_row";
import {PortfolioIncome} from "./portfolio_income_card";
import {AddNewAccountDialog} from "./add-account-dialog";
import {CreateAccountMenuData} from "../AccountPopupMenu/menu-data";
import PotentialDashboard from '../PotentialDashboard/PotentialDashboard';
import PotentialReportAI from '../PotentialReportAI/PotentialReportAI';
import HoldingsCard from '../HoldingsCard/HoldingsCard';
import PerformanceCard from '../PerformanceCard/PerformanceCard';

const priceFontSize = "1.6rem";

class UserComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      id: this.props.username,
      dashboard: null,
      currentBanner: "balances",
      acct_id: "",
      acct_index: -1,
      loading: false,
      mouse_over_aggregate: false,
      debug: false,
      adding_account: false,
    };

    if (props.path === "/user/personal") {
      this.state.currentBanner = "modify_personal_data";
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.acct_id !== this.props.acct_id) {
      this.setState({
        acct_id: this.props.acct_id,
      });
    }

    const dashboard = this.getUserDashboard();
    const is_loading = this.props.userDashboard.loading;

    if ((!dashboard && !is_loading)
      || (this.state.acct_index !== this.props.acct_index
        && prevProps.acct_index !== this.props.acct_index)) {
      this.maybeLoadDashboard();
    }

    if (prevProps.args && this.props.args) {
      if (prevProps.args.chat !== this.props.args.chat
        && this.props.args.chat === "true"
        && Object.keys(this.props.chat).length === 0) {
        this.props.loadChats();
      } else if (!prevProps.ugma_invite && this.props.ugma_invite) {
        maybe_load_invites(this);
      }
    }
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.onKeyPressed);

    const last_segment = this.props.path.split("/").pop();
    const create_acct = this.props.args.create_acct_on_login;

    if (create_acct) {
      this.onAddAccount();
    } else if (!this.getUserDashboard()) { //&& is_user) {
      // Only load the user dashboard if we are confirmed users.
      this.maybeLoadDashboard();
    }

    if (last_segment === "ugma_invite") {
      maybe_load_invites(this);
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.onKeyPressed);
  }

  onKeyPressed = ev => {
    if (ev.code === "KeyD" && ev.ctrlKey) {
      ev.preventDefault();
      const debug = !this.state.debug;
      this.setState({ debug });
    }
  }


  getUsername = () => {
    return this.props.username || this.props.user.username;
  }

  get_address_state = () => {
    const key = "0000";
    const onboarding = this.props.onboarding && this.props.onboarding[key];
    if (onboarding) {
      return onboarding.role_0_state;
    }
    return null;
  }

  get_draw_down = () => {
    const username = this.getUsername();
    const acct_index = this.props.acct_index;
    let draw_down = 0.;
    if (!(username in this.props.securityPurchase)) {
      return draw_down;
    }
    const user_items = this.props.securityPurchase[username];
    if (acct_index === "-1") {
      // load all the items
      Object.values(user_items).forEach(value => {
        draw_down += value.draw_down_usd;
      });
    } else {
      const key = sprintf("%04d", parseInt(acct_index, 10));
      if (key in user_items) {
        draw_down = user_items[key].draw_down_usd;
      }
    }
    return draw_down;
  }

  get_deposits = () => {
    let curr_deposits_usd = 0.;
    const username = this.getUsername();
    const index = parseInt(this.props.acct_index, 10);
    const payment_items = this.props.userPayments
      && this.props.userPayments[username]
      && this.props.userPayments[username].current_payments;
    if (!payment_items) {
      return curr_deposits_usd;
    }
    for(let i=0; i < payment_items.length; i++) {
      const item = payment_items[i];
      if (item.username === username && item.destination_index === index) {
        curr_deposits_usd += item.amt_cents / 100.;
      }
    }
    return curr_deposits_usd;
  }

  get_cash = () => {
    const dashboard = this.getUserDashboard();
    if (!dashboard) {
     return 0.0;
    }
    const cash = dashboard.balances.accts[0].cash;
    if (cash === "PENDING") {
      return 0.;
    }
    return cash;
  }

  getUserDashboard = () => {
    const username = this.getUsername();
    const acct_index = this.props.acct_index;
    const acct_key = acct_index === "-1" ? "ALL" : sprintf("%04d", acct_index);
    if (!this.props.userDashboard
      || !this.props.userDashboard[username]) {
      return null;
    }
    return this.props.userDashboard[username][acct_key];
  }

  getSecurityPurchases = () => {
    const username = this.getUsername();
    const acct_index = this.props.acct_index;
    let items = [];
    let closed_items = [];

    if (!(username in this.props.securityPurchase)) {
      return { items, closed_items };
    }
    const user_items = this.props.securityPurchase[username];
    if (acct_index === "-1") {
      // load all the items
      Object.values(user_items).forEach(value => {
        items = items.concat(value.items);
      });
    } else {
      const key = sprintf("%04d", parseInt(acct_index, 10));
      if (key in user_items) {
        items = user_items[key].items;
        closed_items = user_items[key].closed_items;
      }
    }
    return { items, closed_items };
  }

  maybeLoadDashboard = () => {
    const dash = this.getUserDashboard();
    if (dash) {
      return;
    }
    const date = new Date();
    const dateStr = sprintf("%04d%02d%02d",
      date.getFullYear(), date.getMonth(), date.getDate());
    const chart_colors = this.props.client && this.props.client.chart_colors;
    this.props.loadAccountData(
      this.getUsername(), this.props.acct_index, dateStr, chart_colors);
    this.props.GetPaymentInformation(this.getUsername());
    this.props.loadUserSecurityItems(this.getUsername());
  };

  maybeShowOfferings = () => {
    if (!this.props.show_offerings) {
      return null;
    }

    return (
      <DashboardContainer
        title={"Offerings"}
        client={this.props.client}>
        <CurrentOfferings
          do_available_cash={true}
          username={this.getUsername()}
          component={this}
          path={this.props.path}
          no_header={true}
          no_table_buttons={true}
          no_margins={true}
          args={this.props.args}/>
      </DashboardContainer>
    );
  }

  getBannerButtons = (is_admin) => {

    const wlf = this.props.app.wlf;
    const no_documents = wlf.ui && wlf.ui.no_document_vault;
    let bannerButtons = [
      { label: "Portfolio", id: "portfolio" },
      { label: "Deposits and Withdrawals", id: "funds",},
      { label: "Documents", id: "documents" },
      { label: "Personal Information", id: "modify_personal_data" },
    ];

    if (this.props.args.acct_index === "-1" || no_documents) {
      bannerButtons = bannerButtons.filter(item => item.id !== "documents");
    }

    if (!is_admin && false) {
      // Disable email icon for now
      const has_unread_email = this.props.inbox.unread_count > 0;
      const icon = has_unread_email ? "fa fa-envelope-open-o" : "fa fa-envelope-o";
      // If we have unread messages, show fa-envelope-open-o
      bannerButtons.push(
        {
          label: (<i className={icon} style={{fontSize: "1.4rem"}}/>),
          id: "email",
        }
      );
    }

    if (wlf.apps && wlf.apps.cd_explorer) {
      bannerButtons.push({
        label: "Current CD Offerings",
        id: "cd_offerings",
      })
    } else {
      /*bannerButtons.push(
        { label: (
            <div style={{display: "inline"}}>
              <span>Retirement Checkup</span>
              <Info
                component={this}
                id={"retirement_checkup"}
                style={info_style}
                popup_style={popup_style}
                text={retire_text}/>
            </div>),
          id: "retirement_checkup" },
      )*/
    }

    const portfolioButtons = [
      { label: "Portfolio", id: "portfolio" },
    ];
    return this.props.acct_id ? portfolioButtons : bannerButtons;
  };

  getUserRoot = () => {
    const rootRE = /^(.*\/user).*/;
    const match = this.props.path.match(rootRE);
    if (!match) {
      throw new Error("Can't parse path", this.props.path);
    }
    return match[1];
  };

  onBannerClick = banner_id => {
    this.setState({
      currentBanner: banner_id,
    });
    const path = this.props.path;
    const args = deep_copy(this.props.args);
    if (banner_id === "modify_personal_data") {
      this.props.navigatePath(this.getUserRoot() + "/personal", args);
      return;
    }

    const user_url = this.getUserRoot();

    if (banner_id === "portfolio" && path !== user_url) {
      if (this.props.username) {
        args.username = this.props.username;
      }
      if (args.table) {
        delete args.table;
      }
      this.props.navigatePath(user_url, args);
    } else if (banner_id === "portfolio" && path === "/super-admin/user") {
      const url = path + "?username=" + this.props.username + "&acct_index=-1";
      this.props.navigatePath(url);
    } else if (banner_id === "funds") {
      const acct_index =
        (this.props.acct_index === "-1" || this.props.acct_index === undefined)
          ? "0"
          : this.props.acct_index;
      let query = "?acct_index=" + acct_index + "&tab=current";
      if (this.props.username) {
        query += "&username=" + this.props.username;
      }
      const payments_url = user_url + "/payments";
      this.props.navigatePath(payments_url + query);
    } else if (banner_id === "email") {

      this.props.navigatePath(user_url + "/email", this.props.args);

    } else if (banner_id === "chat") {
      this.onChatClick()
    } else if (banner_id === "documents") {
      this.props.navigatePath(user_url + "/documents", this.props.args);
    } else if (banner_id === "retirement_checkup") {
      this.props.navigatePath(user_url + "/retirement_checkup", this.props.args);
    } else if (banner_id === "potential") {
      this.props.navigatePath(user_url + "/potential", this.props.args);
    } else if (banner_id === "cd_offerings") {
      args.table = "NON_CALLABLE_CDS";
      this.props.navigatePath(user_url + "/offerings", args);
    } else if (banner_id === "all_accounts_mobile") {
      this.setState({
        show_add_account_dialog: true,
      })
    }
  }

  onChatClick = () => {
    const new_args = deep_copy(this.props.args);
    if (new_args.chat) {
        delete new_args.chat;
    } else {
        new_args.chat = "true";
    }
    this.props.navigatePath(this.props.path, new_args); 
  }

  onChatClickToProps = banner_id => {
    this.setState({
        currentBanner: banner_id,
    });

    this.onChatClick();
  }

  onTitleClick = (title) => {
    const content = `open${title}Content`
    this.setState({
        [content]: !this.state[content],
    });
  }

  renderExpandCollapseSign = (title) => {
      const content = `open${title}Content`
      return this.state[content] ? "-" : "+";
  }

  renderExpandCollapseButton = (title, h1Style={}) => {
    const sign = this.renderExpandCollapseSign(title);  
    return <button className= "title title-button-responsive" style={h1Style} onClick={() => this.onTitleClick(title)}>{sign}</button>
  }

  renderTitle = title => {
    const client = this.props.client;
    const div_style = {
        display: "flex",
        justifyContent: "space-between",
    }
    
    const h1Style = {
      color: getRGB(client.color.sign_on_button),
      margin: 0,
    };


    return (
      <div style={div_style}>
        <button className="title" style={h1Style} onClick={() => this.onTitleClick(title)} >{title}</button>
      </div>
    )
  };

  renderHeader = (text, override) => {
    const spanStyle = {
      fontWeight: "bold",
      fontSize: "1.4rem",
      ...override,
    };

    return (<span style={spanStyle}>{ text }</span>);
  };

  renderPrice = (cents, rightPadding, style_override = {}) => {
    const spanStyle = {
      fontSize: priceFontSize,
      paddingRight: rightPadding,
      ...style_override,
    };
    if (cents < 0) {
      spanStyle.color = "#F00";
    }

    if (typeof cents === "number") {
      return (<span style={spanStyle}>{dollarToString(cents)}</span>);
    } else if (typeof cents === "string") {
      return (<span style={spanStyle}>{cents}</span>);
    }
  };

  renderPrice_2 = cents => {
    let color = "#000";
    if (cents > 0) {
      color = "#008040";
    } else if (cents < 0) {
      color = "#F00";
    }
    const style = {
      color
    };
    return (<span style={style}>{dollarToString(cents)}</span>);
  };

  renderPercent = pct => {
    pct *= 100;
    pct = Math.floor(pct * 1e4) / 1e4;
    const spanStyle = {
      //fontSize: priceFontSize,
    };
    if (pct < 0) {
      spanStyle.color = "#F00";
    }
    return (
      <span style={spanStyle}>
        { sprintf("%.4f %%", pct) }
      </span>);
  };

  onMouseOver = (index, sym, mouse_over) => (ev) => {
    if (mouse_over) {
      this.setState({
        selected_sym_index: index,
        selected_sym: sym,
      })
    } else {
      if (this.state.selected_sym_index === index) {
        this.setState({
          selected_sym_index: -1,
          selected_sym: "",
        })
      }
    }
  }

  onAddAccount = () => {
    const segment = onboarding_start_segment(this.props.app.wlf);
    this.setState({ adding_account: true });
    addAccount(this.props.token, this.props.onboarding_token)
      .then(result => {
        this.props.setAccountState(
          result.account_state, result.index, result.token, result.onboarding_token);
        this.setState({
          adding_account: false,
          show_add_account_dialog: false,
        });
        this.props.dataToStore(result.onboarding, result.index);
        this.props.dwollaUpdate(result.dwolla, result.index);
        this.props.tdaUpdate(result.tda, result.index);
        const url = sprintf("/onboarding_%04d/%s", result.index, segment);
        this.props.navigatePath(url);
      });
  }

  renderLoading = () => {
    const divStyle = {
      background: "#FFF",
      padding: "2rem",
      margin: "2rem",
      fontSize: "2rem"
    };

    return (
      <div style={divStyle} align={"center"}>
        <div style={{height: "5rem"}}/>
        { Spinner() }
        <div style={{height: "4rem"}}/>
      </div>
    )
  }

  getTotalCash(accts) {
    const acct_index = parseInt(this.props.acct_index, 10);
    let cash = 0.;

    if (acct_index === -1) {
      accts.forEach(acct => {
        cash += acct.cash;
      })
    } else {
      cash = accts[acct_index].cash;
    }
    return cash;
  }

  getCusipMetadata(dashboard) {
    const all_data = dashboard.holdings.securities.all_data;
    const result = {};
    all_data.forEach(item => {
      if (item.id !== "cash") {
        result[item.id] = item.metadata.security;
      }
    });
    return result;
  }

  /**
   * If there is a wlf_id in props, then return that wlf, otherwise, return the wlf from
   * props.app
   */
  getDisplayWlf = () => {
    const wlf_id = this.props.args && this.props.args.wlf_id;
    if (wlf_id) {
      return this.props.wlfs.find(wlf => wlf.id === wlf_id);
    }
    return this.props.app.wlf;
  }

  maybeRenderDashboards = () => {
    const result = [];

    if (!this.props.path || !this.props.path.endsWith("/user")) {
      return;
    }

    const wlf = this.getDisplayWlf();
    const dashboard = this.getUserDashboard();
    const no_performance = wlf.ui && wlf.ui.no_dashboard_performance;
    const show_corp_events = wlf.ui && wlf.ui.user_dashboard_corp_events;
    const all_holdings = dashboard
      && dashboard.holdings && dashboard.holdings.securities
      && dashboard.holdings.securities.all_data;
    let has_holdings = false;
    if (all_holdings && all_holdings.length === 1 && all_holdings[0].id === "cash" && all_holdings[0].closing_value > 0) {
      // Portfolio is holding nothing but cash.
      has_holdings = true;
    } else if (all_holdings && all_holdings.length > 1) {
      // We're holding items other than cash
      has_holdings = true;
    }
    const { items, closed_items }  = this.getSecurityPurchases();

    if (dashboard && !this.props.acct_id
      && dashboard.balances
        && dashboard.balances.accts.length > 0) {

      if (items.length > 0) {
        result.push((
          <SecurityPurchasesCard
            title={"Orders"}
            debug={this.state.debug}
            key={"securityPurchases"}
            items={items}
          />
        ));
      }
      result.push(
        (<Balances
          key={"bal"}
          state={this.state}
          component={this}
          debug={this.state.debug}/>));
      if (has_holdings) {
        result.push(
            <HoldingsCard 
                key={"HoldingsCard"} 
                client={this.props.client}
                holdingsData={this.getUserDashboard().holdings}
            />
        )
      }
      if (show_corp_events && has_holdings
        && dashboard.corp_events && Object.values(dashboard.corp_events).length > 0) {
        const cash = this.getTotalCash(dashboard.balances.accts);
        const cusip_metadata = this.getCusipMetadata(dashboard);
        result.push((
          <USTCard
            key={"UST"}
            client={this.props.client}
            ust={dashboard.ust}/>
        ));
        result.push((
          <CouponStats
            key={"COUPON"}
            corp_events={dashboard.corp_events}
            cash={cash}
            cusip_metadata={cusip_metadata}
            ust={dashboard.ust}
            client={this.props.client}/>
        ));
        result.push((
          <PortfolioIncome
          key={"INCOME"}
          corp_events={dashboard.corp_events}
          client={this.props.client}/>
        ))
      }
      if (!no_performance) {
        // result.push((
        //   <Performance
        //     key={"performance"}
        //     component={this}
        //     args={this.props.args}/>));
        result.push((
            <PerformanceCard 
                key={'PerformanceCard'}
                client={this.props.client}
                performanceData={this.getUserDashboard().performance}
            />
        ))
      }
      if (closed_items.length > 0) {
        result.push((
          <SecurityPurchasesCard
            title={"Trade History"}
            debug={this.state.debug}
            key={"orderHistory"}
            items={closed_items}/>
        ));
      }
    }
    return result;
  };

  maybeRenderPersonal = () => {
    if (!this.props.personal) {
      return null;
    }
    return (<PersonalDashboard username={this.props.username}/>);
  }

  maybeRenderPortfolio = () => {
    if (!this.state.acct_id) {
      return null;
    }
    return (
      <PortfolioDashboard portfolio_id={this.state.acct_id}/>
    );
  };

  maybeRenderPayments = () => {
    if (!this.props.payments) {
      return null;
    }
    return (<PaymentsDashboard
      username={this.props.username}
      path={this.props.path}
      args={this.props.args}
      acct_index={this.props.acct_index}/>);
  };

  maybeRenderEmail = () => {
    if (!this.props.show_email) {
      return null;
    }

    return (<EmailDashboard/>);
  }

  maybeRenderCreatingUser = () => {
    const create_acct = this.props.args.create_acct_on_login;
    if (!create_acct) {
      return null;
    }

    const divStyle = {
      background: "#FFF",
      padding: "2rem",
      margin: "2rem",
      fontSize: "2rem"
    };

    return (
      <div style={divStyle} align={"center"}>
        <div style={{height: "5rem"}}/>
        <span>Creating new account.</span>
        <div>
          { Spinner() }
        </div>
        <div style={{height: "4rem"}}/>
      </div>
    )
  }

  generateMenuData = () => {
    const dashboard = this.getUserDashboard();
    if (!dashboard || !dashboard.menu_data) {
      return null;
    }
    const menu_data = deep_copy(dashboard.menu_data);
    menu_data.forEach((data, index) => {
      const args = deep_copy(this.props.args);
      args.acct_index = sprintf("%d", index);
      data.url = this.props.path + objToUrlParam(args);
      data.type = AccountTypeLabel(data.type);
    });
    return menu_data;
  };

  determineBannerMenu = (userMenu, superAdminMenu) => {
      return this.props.bannerMenuProps ? superAdminMenu : userMenu;
  }

  displaySecondBanner = (secondBanner) => {
      if((this.props.app.width <= DEVICE_WIDTH.large) || !this.props.bannerMenuProps) {
          return;
      }
      return (<BannerMenu {...secondBanner}/>)
  }

  maybeRenderChat = () => {
    // on page refresh, props.chat needs to be populated again
    // if chat is null or contains no data, render empty chat window
    if (!this.props.chat || Object.keys(this.props.chat).length < 1) {
        return (
          <Chat
            user={this.props.user}
            onChatClick={this.onChatClickToProps}
            banner_id={'chat'} />
        );
    }

    // otherwise, render each chat window by the chat id
    for (let chatId in this.props.chat) {
        return (
          <Chat
            chatData={this.props.chat[chatId]}
            user={this.props.user}
            onChatClick={this.onChatClickToProps}
            banner_id={'chat'}/>
        );
    }
  }

  maybeRenderUGMAInvite = () => {
    if (!this.props.ugma_invite) {
      return null;
    }
    return (
      <UGMAInvite state={this.state} component={this}/>
    );
  }

  maybeRenderIRAMinDistrib = () => {
    const loading = this.props.userDashboard.loading;
    if (loading) {
      return null;
    }
    const segment = this.props.path.split('/').pop();
    if (segment !== "retirement_distribution") {
      return null;
    }

    return (<IRAMinimumDistribution/>);
  }

  maybeRenderRetirementCalc = () => {
    const loading = this.props.userDashboard.loading;
    if (loading) {
      return null;
    }
    const segment = this.props.path.split('/').pop();
    if (segment !== "retirement_checkup") {
      return null;
    }

    return (<RetirementCalculator/>);
  }

  maybeRenderDocuments = () => {
    const segment = this.props.path.split('/').pop();
    if (segment !== "documents") {
      return null;
    }
    return (
      <Statements
        dashboard={this.getUserDashboard()}
        username={this.getUsername()}
        acct_index={parseInt(this.props.acct_index, 10)}
        args={this.props.args}
        path={this.props.path}
      />
    )
  }

  maybeRenderPotential = () => {
    const dashboard = this.getUserDashboard();
    const username = this.getUsername();
    const index = this.props.args.acct_index;
    const all_holdings = dashboard &&
    dashboard.holdings &&
    dashboard.holdings.securities &&
    dashboard.holdings.securities.all_data;

    let has_holdings = false;
    if (all_holdings && all_holdings.length === 1 && all_holdings[0].id === "cash" && all_holdings[0].closing_value > 0) {
        // Portfolio is holding nothing but cash.
        has_holdings = true;
    } else if (all_holdings && all_holdings.length > 1) {
        // We're holding items other than cash
        has_holdings = true;
    }
    const segment = this.props.path.split('/').pop();
    if (segment !== "potential") {
      return null;
    }

    return (
        <React.Fragment>
            <PotentialDashboard
                username={username}
                args={this.props.args}
            />
            {has_holdings &&
                <HoldingsCard 
                    client={this.props.client}
                    holdingsData={this.getUserDashboard().holdings}
                    showCharts={false}
                />
            }
            <PotentialReportAI 
                username={username}
                index={index}
            />
        </React.Fragment>
    );
  }

  renderAddAccountButton = () => {
    const no_add_acct_button = this.props.app.wlf.ui && this.props.app.wlf.ui.no_add_account_button;
    if (no_add_acct_button || this.is_mobile()) {
      return null;
    }
    const bg_mult = this.state.over_add_account ? 1.2 : 1;
    const action_style = {
      padding: "0.2rem 0.5rem",
      marginRight: "2rem",
    }

    const on_mouse_over = (over) => () => {
      this.setState({
        over_add_account: over,
      })
    }

    const on_click = () => {
      this.setState({
        show_add_account_dialog: true,
      })
    }

    return (
      <div
        onMouseEnter={on_mouse_over(true)}
        onMouseLeave={on_mouse_over(false)}>
        <Action
          style={action_style} bg_mult={bg_mult} onClick={on_click}>
          Add Another Account
        </Action>
      </div>
    )
  }

  is_mobile = () => {
    return this.props.app.width < DEVICE_WIDTH.large;
  }

  on_select_index = new_acct_index => {
    console.log("on_select_index", new_acct_index, "args", this.props.args);
    const args = deep_copy(this.props.args);
    args.acct_index = new_acct_index;
    this.props.navigatePath(this.props.path, args);
    this.setState({
      show_add_account_dialog: false,
    })
  }

  render = () => {
    const loading = this.props.userDashboard.loading;
    const client = this.props.client;
    const banner_color = getRGB(client.color.banner_background);
    const banner_text_color = getRGB(client.color.banner_text);

    const aggregate_url = this.getUserRoot() + "?username=" + this.props.username
      + "&acct_index=-1";

    const label_style = {
      paddingTop: "1rem",
      paddingBottom: "1rem",
    }
    const right_justify = this.props.app.width >= DEVICE_WIDTH.large;
    const right_button = this.is_mobile()
      ?
      {
        label: (<div style={label_style}>All Accounts</div>),
        id: "all_accounts_mobile",
      } :
      {
        label: (
          <TextLoading
            style={label_style}
            loading={this.state.adding_account}
            spinner_style={{ fontSize: "1.5rem", paddingTop: "0.8rem"}}
            label="All Accounts"/>
        ),
        id: "all_accounts",
        popup: (
          <AccountPopupMenu
            acct_index={this.props.acct_index}
            path={this.props.path}
            args={this.props.args}
            set_menu_data={this.props.set_menu_data}
            menu_data={this.generateMenuData()}
            on_add_account={this.onAddAccount}
            adding_account={this.state.adding_account}
            show_aggregate={this.props.show_aggregate}
            aggregate_url={aggregate_url}
            menu_id={"all_accounts"}/>
        ),
        popup_style: {
          transform: sprintf("translate(%drem, 0rem)", right_justify ? -9 : 0),
          width: "18rem",
        },
    };
    const banner_style = {
      paddingLeft: "7rem",
    }
    if (right_justify) {
      banner_style.paddingRight = "8.1rem";
    }

    const userBannerMenu = {
      buttons: this.getBannerButtons(false),
      bannerColor: banner_color,
      bannerTextColor: banner_text_color,
      style: banner_style,
      onClick: this.onBannerClick,
      right_button,
      right_inner_elem: this.renderAddAccountButton(),
      current: this.state.currentBanner,
      isMobile: this.is_mobile(),
    };

    const dialog = this.state.show_add_account_dialog
      ? (<AddNewAccountDialog
        isMobile={this.is_mobile()}
        component={this}
        client={this.props.client}
        on_select_index={this.on_select_index}
        acct_index={parseInt(this.props.acct_index, 10)}
        menu_data={CreateAccountMenuData(this.props.user, this.props.tda)}
        on_add_account={this.onAddAccount}
        adding_account={this.state.adding_account}
      />)
      : null;

    return (
      <div>
        <BannerMenu {...userBannerMenu}/>

        <div className='img-col'>
          <div className="page-container">
            <div className="container">
              <Greeting
                username={this.props.username}
                path={this.props.path}
                component={this}
                state={this.state}
                acct_index={this.props.acct_index}/>
              { loading && this.renderLoading() }
              { !loading && this.maybeRenderCreatingUser() }
              { !loading && this.maybeRenderDashboards() }
              { !loading && this.maybeRenderPersonal() }
              { !loading && this.maybeRenderUGMAInvite() }
              { !loading && this.maybeRenderPortfolio() }
              { !loading && this.maybeRenderPayments() }
              { !loading && this.maybeRenderEmail() }
              { !loading && this.maybeRenderDocuments() }
              { !loading && this.maybeRenderPotential() }
              { !loading && this.maybeShowOfferings() }
              { !loading && this.props.args.chat && this.maybeRenderChat() }
              { this.maybeRenderIRAMinDistrib() }
              { this.maybeRenderRetirementCalc() }
            </div>
          </div>
          { dialog }
        </div>
      </div>
    );
  }
}

export { UserComponent };
